import { getDate } from "~/common/utils/ApiHelper";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { UpdatedContractOverviewData } from "~/features/contracts/redux/types";
import type { ContractListResponseDTO, ContractOverviewDTO, ContractPriceDTO, ContractSearchRequestDTO } from "./dto";

export type ContractsOverviewParams = ContractSearchRequestDTO;

const apiUrl = occUrl("/contract/search");

export async function fetchContractsOverview(
  params: ContractsOverviewParams = {},
): Promise<UpdatedContractOverviewData[]> {
  const response = await occFetch(apiUrl, {
    body: JSON.stringify(params),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Error fetching data! Code ${response.status} - ${response.statusText}`);
  }

  const wrapper = (await response.json()) as ContractListResponseDTO;
  return (wrapper.contracts ?? []).map(transformContractOverviewDTO);
}

export function transformContractOverviewDTO(dto: ContractOverviewDTO): UpdatedContractOverviewData {
  return {
    contractNumber: dto.contractNumber ?? "",
    startDate: toDate(dto.startDate),
    endDate: toDate(dto.endDate),
    designation: dto.designation ?? "",
    materialNumber: dto.materialNumber ?? "",
    customerMaterialNumber: dto.customerMaterialNumber ?? "",
    status: dto.status ?? "",
    netPrice: transformContractPrice(dto.netPrice),
    disposition: toDate(dto.disposition),
    detailsUrl: dto.detailsUrl ?? "",
  };
}

export function transformContractPrice(dto?: ContractPriceDTO | null): UpdatedContractOverviewData["netPrice"] {
  return {
    currencyIso: dto?.currencyIso ?? "",
    value: dto?.value ?? 0,
    priceType: dto?.priceType ?? "BUY",
    formattedValue: dto?.formattedValue ?? "",
  };
}

function toDate(value?: string | null): Date | undefined {
  return value ? getDate(value) : undefined;
}
